export default {
      id: "weborama-usage",
      viewBox: "0 0 12 12",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#weborama-usage",
      toString: function () {
        return this.url;
      }
    }